import Immutable from 'seamless-immutable';
// ---- external imports ----

import { DRAGGABLE_COMPONENTS, PRODUCT_TYPES } from '~/lib/constants';
// import { STICKY_NOTES } from '~/lib/stickyNotes';
// ---- internal imports ----

import * as types from './actionTypes';
// ---- local imports ----

const initialState = Immutable({
	cashUpdates: {
		show: false,
		updates: [],
		lastUpdate: Date.now()
	},
	activeModal: null,
	previouslyActiveModal: null,
	draggableComponentsVisibility: getInitialDraggablesVisibility(),
	shouldDisplayPowerModalForProcurementScreen: false,
	shouldDisplayPowerModalForHrScreen: false,
	sellingPricesChanged: {
		[PRODUCT_TYPES.COUCH]: false,
		[PRODUCT_TYPES.CHAIR]: false,
		[PRODUCT_TYPES.TABLE]: false
	},
	activeComponents: [],
    activeIncomeStatementTutorial: null,
    activeBalanceSheetTutorial: null,
    activeFinancialRatiosTutorial: null,
	isFinancialStatementTutorialAutomated: false,
	hasPendingCustomerTypeHint: false,
	shouldShowLevelStory: false,
	hasClosedNewLevelModal: false,
	Request: false,
	showNetworkErrorModal: false,
	levelFailedReviewMode: false,
	gameMenuReturnRoute: '',
});

function reduce(state = initialState, action = {}) {
	switch (action.type) {
	case types.UI_HIDE_BALANCE_SHEET_TUTORIAL:
		return state.merge({
			activeBalanceSheetTutorial: null,
			isFinancialStatementTutorialAutomated: false,
		});
	case types.UI_HIDE_INCOME_STATEMENT_TUTORIAL:
		return state.merge({
			activeIncomeStatementTutorial: null,
			isFinancialStatementTutorialAutomated: false,
		});
	case types.UI_HIDE_FINANCIAL_RATIOS_TUTORIAL:
		return state.merge({
			activeFinancialRatiosTutorial: null,
			isFinancialStatementTutorialAutomated: false,
		});
	case types.UI_SHOW_BALANCE_SHEET_TUTORIAL:
		return state.merge({
			activeBalanceSheetTutorial: action.tutorialKey,
			isFinancialStatementTutorialAutomated: action.isAutomated,
		});
	case types.UI_SHOW_INCOME_STATEMENT_TUTORIAL:
		return state.merge({
			activeIncomeStatementTutorial: action.tutorialKey,
			isFinancialStatementTutorialAutomated: action.isAutomated,
		});
	case types.UI_SHOW_FINANCIAL_RATIOS_TUTORIAL:
		return state.merge({
			activeFinancialRatiosTutorial: action.tutorialKey,
			isFinancialStatementTutorialAutomated: action.isAutomated,
		});
	case types.UI_ACTIVE_MODAL_CHANGED:
		return state.merge({
			activeModal: action.modalName,
		});
	case types.UI_SET_PREVIOUSLY_ACTIVE_MODAL:
		return state.merge({
			previouslyActiveModal: action.modalName ?? null
		});
	case types.UI_SET_GAME_MENU_RETURN_ROUTE:
		return state.merge({
			gameMenuReturnRoute: action.route
		});
	case types.UI_PROCUREMENT_DISMISSED_POWER_MODAL:
		return state.merge({
			shouldDisplayPowerModalForProcurementScreen: action.isShown
		});
	case types.UI_SET_HR_POWER_MODAL_VISIBLE:
		return state.merge({
			shouldDisplayPowerModalForHrScreen: action.isShown
		});
	case types.UI_ADD_NEW_EXPENSE_TO_DISPLAY:
	case types.UI_ADD_EXPENSE_TO_DISPLAY:
	case types.UI_ADD_INCOME_TO_DISPLAY:
		return state.merge({
			cashUpdates: {
				show: true,
				updates: [...state.cashUpdates.updates, action.cashUpdate],
				lastUpdate: Date.now()
			}
		});
	case types.UI_RESET_DISPLAYED_CASH_UPDATES:
		return state.merge({
			cashUpdates: {
				show: false,
				updates: [],
				lastUpdate: Date.now(),
			}
		});
	case types.UI_DRAGGABLE_COMPONENT_SHOW:
		return state.merge({
			draggableComponentsVisibility: {
				...state.draggableComponentsVisibility,
				[action.componentName]: action.isVisible
			}
		}, { deep: true });;
	case types.UI_PRODUCTS_PRODUCT_SELLING_PRICE_CHANGED:
		return state.merge({
			sellingPricesChanged: action.updatedSellingPricesChanged
		});
	case types.UI_ACTIVE_COMPONENT_ADDED:
		return addActiveComponent(state, action.activeComponentName);
	case types.UI_ACTIVE_COMPONENT_REMOVED:
		return removeActiveComponent(state, action.activeComponentName);
	case types.UI_UPDATE_HAS_PENDING_CUSTOMER_TYPE_HINTS:
		return state.merge({
			hasPendingCustomerTypeHint: action.hasPendingCustomerTypeHint
		});
	case types.UI_UPDATE_SHOULD_SHOW_LEVEL_STORY:
		return state.merge({
			shouldShowLevelStory: action.shouldShowLevelStory
		});
	case types.UI_LEVEL_NEW_MODAL_CLOSED:
		return state.merge({
			hasClosedNewLevelModal: action.closed,
		});
	case types.UI_SHOW_NETWORK_ERROR_MODAL:
		return state.merge({
			showNetworkErrorModal: true,
		});
	case types.UI_HIDE_NETWORK_ERROR_MODAL:
		return state.merge({
			showNetworkErrorModal: false,
		});
	case types.UI_ENTER_LEVEL_FAILED_REVIEW_MODE:
		return state.merge({
			levelFailedReviewMode: true,
		});
	case types.UI_EXIT_LEVEL_FAILED_REVIEW_MODE:
		return state.merge({
			levelFailedReviewMode: false,
		});
	default:
		return state;
	}
}

function addActiveComponent(state, componentName) {
	const activeComponents = state.activeComponents.asMutable();
	if (['main_screen', 'procurement', 'game_menu'].includes(componentName))
		return state.merge({
			activeComponents: [componentName]
		});
	else
		activeComponents.push(componentName);

	return state.merge({
		activeComponents: activeComponents
	});
}

function removeActiveComponent(state, componentName) {
	const activeComponents = state.activeComponents.asMutable();

	if (activeComponents.length === 0) {
		return state;
	}

	const lastActiveComponentName = activeComponents[activeComponents.length - 1];
	if (lastActiveComponentName !== componentName) {
		return state;
	}

	activeComponents.pop();

	return state.merge({
		activeComponents: activeComponents
	});
}

function getInitialDraggablesVisibility() {
	let draggableVisibility = {};
	Object.keys(DRAGGABLE_COMPONENTS)
		.map((DrgCompName) => { draggableVisibility[DrgCompName] = false ; });
	return draggableVisibility;
};
export default reduce;
